// extracted by mini-css-extract-plugin
module.exports = {"separator":"style-module--separator--3ym8R","margTop":"style-module--margTop--3mc_r"};